// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Security: Get environment variables without fallbacks
// If these are missing, the application should fail fast
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Validate required environment variables
if (!SUPABASE_URL) {
  throw new Error(
    'VITE_SUPABASE_URL is required but not set. ' +
    'Check your .env file and ensure VITE_SUPABASE_URL is configured. ' +
    'Refer to .env.example.secure for the correct template.'
  );
}

if (!SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    'VITE_SUPABASE_PUBLISHABLE_KEY is required but not set. ' +
    'Check your .env file and ensure VITE_SUPABASE_PUBLISHABLE_KEY is configured. ' +
    'Refer to .env.example.secure for the correct template.'
  );
}

// Validate URL format
try {
  new URL(SUPABASE_URL);
} catch {
  throw new Error(
    `VITE_SUPABASE_URL is not a valid URL: "${SUPABASE_URL}". ` +
    'Expected format: https://your-project-id.supabase.co'
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
});